enum EAutomatedEmailTab {
  SETTINGS = 'settings',
  OUTBOX = 'outbox',
  SENT = 'sent',
  DASHBOARD = 'dashboard',
}

type TAutomatedEmailTab = {
  key: EAutomatedEmailTab;
  label: string;
};

/** Matches `Modules\AutomatedEmail\Enums\DomainStateEnum`. */
type TAutomatedEmailDomainState = 'pending' | 'active' | 'failed';

export type { TAutomatedEmailTab, TAutomatedEmailDomainState };
export { EAutomatedEmailTab };
